<template>
  <div class="mod-config">
    <el-form :inline="true" :model="searchForm" @keyup.enter.native="getDataList()">
      <el-form-item>
        <el-select v-model="searchType" :placeholder="$t('paymentRecord.selectSearchCondition')" clearable style="width: 150px">
          <el-option :label="$t('common.all')" value="" />
          <el-option :label="$t('paymentRecord.date')" value="date" />
          <el-option :label="$t('paymentRecord.coach')" value="coach" />
          <el-option :label="$t('paymentRecord.customer')" value="customer" />
          <el-option :label="$t('appointmentUnpaid.method')" value="method" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="searchType==='date'">
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          :range-separator="$t('common.to')"
          :start-placeholder="$t('paymentRecord.startDate')"
          :end-placeholder="$t('paymentRecord.endDate')"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']" />
      </el-form-item>
      <el-form-item v-if="searchType==='coach'">
        <el-select v-model="searchForm.jiaolianbianhao" :placeholder="$t('paymentRecord.selectCoach')" clearable filterable style="width: 180px">
          <el-option v-for="c in coaches" :key="c.id" :label="c.jiaolianxingming" :value="c.jiaolianbianhao" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="searchType==='customer'">
        <el-input v-model="searchForm.xingming" :placeholder="$t('paymentRecord.customerName')" clearable />
      </el-form-item>
      <el-form-item v-if="searchType==='method'">
        <el-select v-model="searchForm.paymentMethod" :placeholder="$t('appointmentUnpaid.selectMethod')" clearable style="width: 150px">
          <el-option :label="$t('appointmentUnpaid.onlinePayment')" :value="1" />
          <el-option :label="$t('appointmentUnpaid.storePayment')" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getDataList">{{ $t('common.search') }}</el-button>
        <el-button @click="resetForm">{{ $t('common.reset') }}</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="dataList" border v-loading="loading" style="width: 100%">
      <el-table-column prop="id" :label="$t('appointmentUnpaid.appointmentId')" width="100" align="center" />
      <el-table-column prop="jiaolianxingming" :label="$t('paymentRecord.coach')" width="120" align="center" />
      <el-table-column prop="xingming" :label="$t('paymentRecord.customer')" width="120" align="center" />
      <el-table-column prop="shouji" :label="$t('appointmentUnpaid.phone')" width="140" align="center" />
      <el-table-column prop="startTime" :label="$t('appointmentUnpaid.startTime')" width="180" align="center" />
      <el-table-column prop="endTime" :label="$t('appointmentUnpaid.endTime')" width="180" align="center" />
      <el-table-column prop="duration" :label="$t('appointmentUnpaid.duration')" width="110" align="center" />
      <el-table-column prop="price" :label="$t('appointmentUnpaid.amount')" width="100" align="center" />
      <el-table-column :label="$t('appointmentUnpaid.paymentMethod')" width="120" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.paymentMethod===1" type="primary">{{ $t('appointmentUnpaid.onlinePayment') }}</el-tag>
          <el-tag v-else-if="scope.row.paymentMethod===2" type="warning">{{ $t('appointmentUnpaid.storePayment') }}</el-tag>
          <el-tag v-else type="info">{{ $t('appointmentUnpaid.other') }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column :label="$t('appointmentUnpaid.paymentStatus')" width="120" align="center">
        <template slot-scope="scope">
          <el-tag type="warning">{{ $t('appointmentUnpaid.unpaid') }}</el-tag>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
    />
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      dateRange: [],
      searchForm: {
        jiaolianbianhao: '',
        xingming: '',
        paymentMethod: ''
      },
      searchType: '',
      coaches: []
    }
  },
  created () {
    this.getCoaches()
    this.getDataList()
  },
  methods: {
    getCoaches () {
      this.$http({ url: '/jiaolian/list', method: 'get', params: { page: 1, limit: 1000 } })
        .then(({ data }) => {
          if (data && data.code === 0) this.coaches = data.data.list || []
        })
    },
    getDataList () {
      this.loading = true
      const params = {
        page: this.pageIndex,
        limit: this.pageSize,
        paymentStatus: 0, // 未付款
        sort: 'start_time',
        order: 'desc'
      }
      if (this.searchType==='coach' && this.searchForm.jiaolianbianhao) params.jiaolianbianhao = this.searchForm.jiaolianbianhao
      else if (this.searchType==='customer' && this.searchForm.xingming) params.xingming = `%${this.searchForm.xingming}%`
      else if (this.searchType==='method' && this.searchForm.paymentMethod) params.paymentMethod = this.searchForm.paymentMethod
      else if (this.searchType==='date' && this.dateRange && this.dateRange.length === 2) {
        params.start_time_start = this.dateRange[0]
        params.start_time_end = this.dateRange[1]
      }
      this.$http({ url: '/jiaolianyuyue/page', method: 'get', params })
        .then(({ data }) => {
          if (data && data.code === 0) {
            this.dataList = data.data.list || []
            this.total = data.data.total || 0
          } else {
            this.dataList = []
            this.total = 0
            this.$message.error(data.msg || '获取数据失败')
          }
        })
        .catch(() => {
          this.dataList = []
          this.total = 0
          this.$message.error('获取数据失败')
        })
        .finally(() => { this.loading = false })
    },
    sizeChangeHandle (val) { this.pageSize = val; this.pageIndex = 1; this.getDataList() },
    currentChangeHandle (val) { this.pageIndex = val; this.getDataList() },
    resetForm () {
      this.searchForm = { jiaolianbianhao: '', xingming: '', paymentMethod: '' }
      this.dateRange = []
      this.searchType = ''
      this.getDataList()
    }
  }
}
</script>

<style scoped>
.mod-config { padding: 20px; }
</style>


